import { render, staticRenderFns } from "./EventTypeMng.vue?vue&type=template&id=3908cc4f&scoped=true"
import script from "./EventTypeMng.vue?vue&type=script&lang=js"
export * from "./EventTypeMng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3908cc4f",
  null
  
)

export default component.exports